import { Box } from "@chakra-ui/react";
import React from "react";
import { colors } from "../../constants/design.constants";

const BaseContainer: React.FC<any> = (props: any) => {
  const { children, styles } = props;

  return (
    <Box
      width={{ md: "100%" }}
      maxWidth={{ base: "100%", md: "640px" }}
      mt={{ base: "0", md: "24px" }}
      mx={{ base: "16px", md: "auto" }}
      p="24px"
      borderRadius="2px"
      bg={colors.elevated}
      border={`1px solid ${colors.border}`}
      {...styles}
    >
      <Box>{children}</Box>
    </Box>
  );
};

export default BaseContainer;
